import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { isInitialMeLoad, useMe } from '@/api/domains/merchant-settings';

/**
 * Hard-locks the admin for merchants whose Shopify plan can't use the carrier
 * service (calculated shipping) API - the app can't show InPost rates at
 * checkout for them, so it redirects to the `/plan-required` upgrade screen.
 *
 * Like OnboardingGate, it fails open: it only acts on a definitive
 * `carrier_service_eligible === false` from the backend, staying out of the way
 * while `me` loads, on error, or while eligibility is still unknown (`null`).
 */
export function CarrierServiceGate({ children }: { children: ReactNode }) {
  const meQuery = useMe();

  if (isInitialMeLoad(meQuery)) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">Loading…</div>
    );
  }

  if (meQuery.data?.merchant.carrier_service_eligible === false) {
    return <Navigate to="/plan-required" replace />;
  }

  return children;
}
